import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import OptimizedImage from '@/components/OptimizedImage';
import GrainTexture from '@/components/GrainTexture';
import GeoPattern from '@/components/GeoPattern';
import homeHeroImage from '@/assets/webp bestanden/7 - TwentyTwelvePhotography_Systemique.webp?w=1200&format=webp&quality=78';
import homeHeroSrcset from '@/assets/webp bestanden/7 - TwentyTwelvePhotography_Systemique.webp?w=480;800;1200&format=webp&quality=78&as=srcset';

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const services = [
    'Organisatieopstellingen',
    'Leiderschapsontwikkeling',
    'Systemische opleidingen'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
    }, 3000); // Wisselt elke 3 seconden

    return () => clearInterval(interval);
  }, [services.length]);

  return (
    <header className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 bg-[#F2EADF]">
      <GeoPattern />
      
      {/* Achtergrond afbeelding overlay */}
      <div className="absolute inset-0 z-0 opacity-20 mix-blend-overlay">
        <OptimizedImage 
          src={homeHeroImage}
          srcSet={homeHeroSrcset}
          sizes="100vw"
          alt="Systemisch werk en coaching - Systemique Castricum voor organisatieopstellingen en teamcoaching" 
          className="w-full h-full object-cover object-[center_35%]"
          priority={true}
          width={1600}
          height={1067}
        />
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] md:w-[500px] md:h-[500px] lg:w-[600px] lg:h-[600px] bg-gradient-to-tr from-[#854C73]/40 via-[#F9EBEF]/30 to-transparent rounded-full blur-3xl opacity-60 animate-pulse-slow"></div>
      <GrainTexture opacity={0.3} />

      <div className="relative max-w-5xl mx-auto px-6 text-center z-10">
        <div className="animate-fade-up">
          <span className="inline-block mb-6 text-xs font-bold tracking-[0.3em] uppercase text-[#590D0D]">Systemisch Werk & Coaching</span>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[1.1] mb-8 text-[#854C73]">
            Inzicht in <br />
            <span className="italic font-light font-serif">verbinding</span> & patronen
          </h1>
          <p className="text-lg md:text-xl text-[#854C73]/80 max-w-2xl mx-auto mb-12 leading-relaxed font-light">
            Ontdek de onderstroom, maak zichtbaar wat er onbewust speelt, zodat er ruimte komt voor beweging. Voor organisaties en individuen
          </p>
          <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
            <div className="mystic-purple-wrapper">
              <Link to="/aanbod" className="mystic-purple-btn flex items-center gap-2">
                Bekijk het aanbod <ArrowRight size={18} aria-hidden="true" />
              </Link>
            </div>
            <Button 
              asChild 
              variant="outline" 
              size="lg"
              className="rounded-full border border-[#854C73]/30 hover:border-[#854C73] text-[#854C73]"
            >
              <Link to="/over">
                Mijn werkwijze
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;